import { getCommentList, getExtraData } from 'api/api';
import { useEffect, useState } from 'react';

import AddComment from 'components/blog/comments/add-comment';
import ButtonContainer from 'core/button-container';
import CommentItem from 'components/blog/comments/comment-item';
import ErrorMessage from 'components/widgets/error-message';
import LoadingTable from 'components/widgets/loading-table';
import { PinkButton } from 'core/buttons/buttons';
import PropTypes from 'prop-types';
import Title from 'core/title';
import { usePageInfo } from 'context/PageInfoContext';
import { useScroll } from 'hooks';
import { useTranslations } from 'next-intl';

const CommentList = ({ handleAddComment }) => {
    const t = useTranslations('comments');
    const [data, setData] = useState([]);
    const [nextUrl, setNextUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [loadCommentList, setLoadCommentList] = useState(false);
    const { pageInfo } = usePageInfo();

    const pageCode = pageInfo.page_context.code;
    const isRemote = pageInfo.page_context.is_remote;

    const params = {
        object_code: pageCode,
        object_name: isRemote ? 'page_remote' : 'page_page'
    };

    useEffect(() => {
        setTimeout(() => {
            setLoadCommentList(true);
            getCommentDataList(params);
        }, 3000);
    }, [pageCode]);

    useScroll((scroll) => {
        if (scroll > 0 && !loadCommentList) {
            setLoadCommentList(true);
            getCommentDataList(params);
        }
    }, [loadCommentList]);

    const getCommentDataList = async (params) => {
        const responsePromise = getCommentList(params);

        responsePromise
            .then((result) => {
                setData(result.results);
                setLoading(false);
                setNextUrl(result.next);
            })
            .catch((_err) => {
                setError(true);
            });
    };

    const handleClick = () => {
        const responsePromise = getExtraData(nextUrl);

        responsePromise
            .then((result) => {
                setData(data => [...data, ...result.results]);
                setNextUrl(result.next);
            })
            .catch((_err) => {
                // setError(true);
            });
    };

    const onAddComment = (comment) => {
        setData(data => [comment, ...data]);
        if (typeof handleAddComment === 'function') {
            handleAddComment();
        }
    };

    return (
        <section>
            {!loading && !error && data !== null && data.length > 0 && loadCommentList &&
                <meta itemProp="commentCount" content={data.length}></meta>
            }

            <AddComment pageCode={pageCode} isRemote={isRemote} onAddComment={onAddComment} />
            { !loading && !error && data !== null && data.length > 0 &&
                <Title content={t('comment-list')} titleType="subtitle" />
            }
            {loading && !error && <LoadingTable />}
            {!loading && error && <ErrorMessage /> }
            {!loading && !error && data !== null && data.length > 0 && loadCommentList &&
                data.map((item, index) => {
                    return <CommentItem key={index} data={item} />;
                })
            }
            {!loading && !error && data !== null && data.length > 0 && nextUrl !== null &&
                <ButtonContainer>
                    <PinkButton
                        label={t('load-more')}
                        onClick={handleClick}
                    />
                </ButtonContainer>
            }
        </section>
    );
};

CommentList.propTypes = {
    pageCode: PropTypes.string,
    isRemote: PropTypes.bool,
    handleAddComment: PropTypes.func
};

export default CommentList;
